/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProjectFieldDto } from '../../models/backend-project-field-dto';

export interface ProjectsProjectFieldsList$Params {
  /**
   * Filter by model
   */
  model?: string;
}

export function projectsProjectFieldsList(
  http: HttpClient,
  rootUrl: string,
  params?: ProjectsProjectFieldsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendProjectFieldDto>>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectFieldsList.PATH, 'get');
  if (params) {
    rb.query('model', params.model, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendProjectFieldDto>>;
    }),
  );
}

projectsProjectFieldsList.PATH = '/api/projects/project-fields/';
